import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { UtilsModule } from '@ot/ifta/utils';
import { SharedBaidPickerModule } from '@ot/shared/baid-picker';
import { SharedLegalNoticeModule } from '@ot/shared/legal-notice';
import { DataGridModule } from '@ot/shared/data-grid';
import { DynamicFormModule } from '@ot/shared/dynamic-form';
import { FilterBuilderModule } from '@ot/shared/filter-builder';
import { PaginationModule } from '@ot/shared/pagination';
import { FilingModalComponent } from './filing-modal/filing-modal.component';
import { FuelReceiptImportModalComponent } from './fuel-receipt-import-modal/fuel-receipt-import-modal.component';
import { FuelReceiptModalComponent } from './fuel-receipt-modal/fuel-receipt-modal.component';
import { TotalRowComponent } from './total-row/total-row.component';
import { UploadFuelModalComponent } from './upload-fuel-modal/upload-fuel-modal.component';

@NgModule({
  declarations: [
    FilingModalComponent,
    FuelReceiptImportModalComponent,
    TotalRowComponent,
    UploadFuelModalComponent,
    FuelReceiptModalComponent
  ],
  imports: [
    CommonModule,
    SharedBaidPickerModule,
    DataGridModule,
    DynamicFormModule,
    FilterBuilderModule,
    PaginationModule,
    UtilsModule
  ],
  exports: [
    FilterBuilderModule,
    FilingModalComponent,
    FuelReceiptImportModalComponent,
    TotalRowComponent,
    UploadFuelModalComponent,
    FuelReceiptModalComponent
  ],
  providers: [DatePipe, DecimalPipe]
})
export class UIModule {}
